import React from 'react';
import intl from 'react-intl-universal';
import { Modal } from 'antd';
import CommonPanel from '../CommonPanel/CommonPanel';
import './SaveFile.scss';
import '../common.scss';

export default class SaveFile extends React.Component {
  constructor(props) {
    super(props);

    this.ModalTitle = intl.formatMessage({ id: 'SaveFileForPanel.Modal.Title' });
    
    this.state = {};
  }
  render () {
    const commonPanelProps = {
      operateType: 'save',
      openFileInfo: this.props.openFileInfo,
      customInfo: this.props.customInfo,
      openFileCallback: this.props.openFileCallback,
      saveSucceedCallback: this.props.saveSucceedCallback,
      onSaveToLocalComputer: this.props.onSaveToLocalComputer,
      onSaveAs: this.props.onSaveAs,
      onOpenFileForLocalComputer: this.props.onOpenFileForLocalComputer,
      onOpenFileForUrl: this.props.onOpenFileForUrl,
      activeKey: this.props.activeKey,
      onCancel: this.props.onCancel,
    };

    return <React.Fragment>
      <Modal onCancel={this.props.onCancel} maskClosable={false} centered={true} className="save-file open-save-combine" width="970px" footer={null} visible={true} title={this.ModalTitle}>
        <CommonPanel {...commonPanelProps} />
      </Modal>
    </React.Fragment>
  }
}
